module.exports = __webpack_public_path__ + "img/mystudent.f0f2b309.png";